import React, { useMemo, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import WBtext from "../../../assets/icons/WBtext.svg";

const API_HOST =
  window.location.hostname === "test.workbrook.com"
    ? "https://test.workbrook.us"
    : "https://workbrook.us";

const statusConfig = {
  verified: {
    icon: "✓",
    iconBg: "#4CAF50",
    title: "Company email verified",
    message:
      "Thank you. Your company email has been verified successfully.",
  },
  already_verified: {
    icon: "ℹ",
    iconBg: "#FF9800",
    title: "Already verified",
    message:
      "This company email has already been verified. No further action is needed.",
  },
  error: {
    icon: "✕",
    iconBg: "#f44336",
    title: "Verification failed",
    message: "We could not verify this company email.",
  },
};

const ConfirmCompanyEmail = () => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const token = useMemo(() => {
    const params = new URLSearchParams(search);
    return params.get("token");
  }, [search]);

  useEffect(() => {
    if (token) {
      setLoading(true);
      axios
        .get(`${API_HOST}/employer-verification/confirm-company-email`, {
          params: { token, format: "json" },
        })
        .then((res) => {
          setResult(res.data);
        })
        .catch((err) => {
          const msg =
            err.response?.data?.message ||
            "An error occurred while verifying your company email.";
          setError(msg);
          setResult(err.response?.data || null);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  const outcome = result?.data?.outcome;
  const companyName = result?.data?.company_name;

  const config = loading
    ? null
    : !token
    ? {
        icon: "!",
        iconBg: "#f44336",
        title: "Invalid link",
        message: "This verification link is missing a token.",
      }
    : error && !outcome
    ? {
        icon: "✕",
        iconBg: "#f44336",
        title: "Verification failed",
        message: error,
      }
    : statusConfig[outcome] || {
        icon: result?.status ? "✓" : "✕",
        iconBg: result?.status ? "#4CAF50" : "#f44336",
        title: result?.status ? "Company email verified" : "Verification failed",
        message:
          result?.message ||
          statusConfig.error.message,
      };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        fontFamily: "'Poppins', sans-serif",
        padding: "20px",
      }}
    >
      <img
        alt="Workbrook"
        src={WBtext}
        style={{ height: "28px", marginBottom: "30px" }}
      />
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          padding: "50px 40px",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
        }}
      >
        {loading ? (
          <p style={{ fontSize: "16px", color: "#555" }}>
            Verifying your company email...
          </p>
        ) : (
          <>
            <div
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                background: config.iconBg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: "32px",
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              {config.icon}
            </div>

            <h1
              style={{
                fontSize: "22px",
                fontWeight: 600,
                color: "#1f1f1f",
                margin: "0 0 12px",
              }}
            >
              {config.title}
            </h1>

            <p
              style={{
                fontSize: "15px",
                color: "#555",
                lineHeight: 1.6,
                margin: "0 0 8px",
              }}
            >
              {config.message}
            </p>

            {companyName && (
              <p
                style={{
                  fontSize: "14px",
                  color: "#333",
                  margin: "12px 0 0",
                  fontWeight: 600,
                }}
              >
                {companyName}
              </p>
            )}
          </>
        )}

        <hr
          style={{
            border: "none",
            borderTop: "1px solid #eee",
            margin: "30px 0",
          }}
        />

        <p style={{ fontSize: "13px", color: "#999", margin: 0 }}>
          You may close this page. If you have any questions, please contact{" "}
          <a
            href="mailto:support@workbrook.com"
            style={{ color: "#3A6ED4", textDecoration: "none" }}
          >
            support@workbrook.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default ConfirmCompanyEmail;
